import { client } from './client';
import { endpoints } from './endpoints';

export async function assignOrder(ordersUUIDs: string[]): Promise<void> {
  const response = await client.post(endpoints.ASSIGN_ORDER, {
    ordersUUIDs,
  });
  return response.data;
}
